import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { Progress, InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import CardView from "../../../components/common/CardView";
import BaseListPage from "../../../base/BaseListPage";
import IPCRPresenter from "./IPCRPresenter";
import DateRangePicker from "../../../components/common/DateRangePicker";

class IPCRPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new IPCRPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
    this.performancePDF = React.createRef();
  }

  getCollectionName() {
    return "ipcr";
  }

  handleAddOffice() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleViewData(data) {
    this.navigateTo(`/view/${this.getCollectionName()}/${data.id}`);
  }

  async handleDeleteData(data) {
    await this.presenter.deleteObjectUseCase.execute(
      this.getCollectionName(),
      data.id,
    );
    await this.presenter.deleteObjectUseCase.execute("performance", data.id);
    this.refetchData();
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    console.log("OBJECT: ", objects);
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    const excludeFieldsFather = [
      "periodFrom",
      "periodTo",
      "createdAt",
      "stats",
    ];
    const includeTableField = Object.keys(schema.fields).filter(
      (key) => !excludeFieldsFather.includes(key),
    );
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} My Performance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary m-0">{schema.label}</h4>
                    <div className="col-md-5 d-flex justify-content-center">
                      <DateRangePicker
                        fields={["periodFrom", "periodTo", "supervisor.id"]}
                        onFilter={(filterObj) => {
                          console.log("FILTER: ", filterObj);
                          this.searchSubmit(filterObj);
                        }}
                      />
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleAddOffice.bind(this)}>
                        <i className="bi bi-plus-lg" /> {schema.collection}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                print={(object) => this.presenter.handlePrint(object)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "performance",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, includeTableField)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(IPCRPage);
